var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.fullscreenloading,
          expression: "fullscreenloading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c(
        "el-tabs",
        { attrs: { type: "border-card" } },
        [
          _c("el-tab-pane", [
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _c("svg-icon", { attrs: { "icon-class": "hike" } }),
                _vm._v("Subscription Info"),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "fieldset",
              { staticClass: "otrfieldset" },
              [
                _c("legend", [_vm._v("General")]),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Tenant"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item",
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "Select Tenant" },
                            model: {
                              value: _vm.form.tenant,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tenant", $$v)
                              },
                              expression: "form.tenant",
                            },
                          },
                          _vm._l(_vm.loggedInUserTenants, function (t) {
                            return _c("el-option", {
                              key: t,
                              attrs: { label: _vm.getTenantLabel(t), value: t },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Organization"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item",
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "Select Organization",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "organization", $$v)
                              },
                              expression: "form.organization",
                            },
                          },
                          _vm._l(_vm.organizations, function (org) {
                            return _c("el-option", {
                              key: org.id,
                              attrs: { label: org.name, value: org.name },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Title"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "400px" },
                          attrs: { placeholder: "Subscription Title" },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                              "margin-top": "5px",
                            },
                          },
                          [_vm._v("e.g. ABC Company Development Program 2026")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Start date"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "Pick a day",
                          },
                          model: {
                            value: _vm.form.startDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "startDate", $$v)
                            },
                            expression: "form.startDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("End date"),
                        _c("span", { staticClass: "otr-red" }, [_vm._v("*")]),
                        _vm._v(":"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "400px" },
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "Pick a day",
                          },
                          model: {
                            value: _vm.form.endDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "endDate", $$v)
                            },
                            expression: "form.endDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "otr-line-spacing__20",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c("el-col", { attrs: { span: 4 } }, [
                      _c("span", { staticClass: "otr-form__label" }, [
                        _vm._v("Status:"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 20 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item",
                            staticStyle: { width: "400px" },
                            attrs: { placeholder: "Select Status" },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "Published", value: "Published" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "Archived", value: "Archived" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.doSave($event)
                },
              },
            },
            [_vm._v("Save & Continue")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.goBack($event)
                },
              },
            },
            [_vm._v("Back")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }